import { render, staticRenderFns } from "./DetailTaxPph23.vue?vue&type=template&id=23ab2adc"
import script from "./DetailTaxPph23.vue?vue&type=script&lang=js"
export * from "./DetailTaxPph23.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports